import { render, staticRenderFns } from "./CustomPSelect.vue?vue&type=template&id=f6af82a0&scoped=true&"
import script from "./CustomPSelect.vue?vue&type=script&lang=js&"
export * from "./CustomPSelect.vue?vue&type=script&lang=js&"
import style0 from "./CustomPSelect.vue?vue&type=style&index=0&id=f6af82a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6af82a0",
  null
  
)

export default component.exports